<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" v-if="userType != '22'">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="订单号" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                  <a-select-option v-for="type in installTypes" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单状态" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes2" :title="type.label" :value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="客户姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.clientName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户联系方式">
                <a-input v-model.trim="queryParam.clientPhone" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业名称" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="品牌" style="margin-left: 55px">
                <a-select v-model="queryParam.brandId" :allowClear="true">
                  <a-select-option v-for="item in data2" :title="item.brandName" :value="item.brandId">{{
                    item.brandName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="型号" style="margin-left: 55px">
                <a-select v-model="queryParam.modelId" :allowClear="true">
                  <a-select-option v-for="item in data3" :title="item.modelName" :value="item.modelId">{{
                    item.modelName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单负责人" style="margin-left: 13px">
                <a-select v-model="queryParam.orderPrincipal" :allowClear="true">
                  <a-select-option v-for="type in data4" :title="type.userName" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅姓名" style="margin-left: 26px">
                <a-input v-model="queryParam.masterName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅电话" style="margin-left: 26px">
                <a-input v-model="queryParam.masterPhone" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="师傅类型" style="margin-left: 26px">
                <a-select v-model="queryParam.workerType" :allowClear="true">
                  <a-select-option v-for="type in restaurantTypes3" :title="type.label" :value="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅星级" style="margin-left: 26px">
                <!--<a-input v-model.trim="queryParam.masterLevel"/>-->
                <a-select v-model="queryParam.masterLevel" :allowClear="true">
                  <a-select-option v-for="type in tech_level" :title="type.label" :key="type.code">{{
                    type.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="购买渠道" style="margin-left: 26px">
                <a-select
                  :allowClear="true"
                  showSearch
                  optionFilterProp="children"
                  @change="changesourceName"
                  :filterOption="filterOption"
                  v-model="queryParam.buyChannelId"
                >
                  <a-select-option v-for="type in selectChannel" :title="type.channelName" :key="type.channelId"
                    >{{ type.channelName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="市场负责人" style="margin-left: 13px">
                <a-select v-model="queryParam.marketPrincipal" :allowClear="true">
                  <a-select-option v-for="type in data5" :title="type.userName" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="建单人" style="margin-left: 39px">
                  <a-input v-model="queryParam.createBy" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="信息来源" style="margin-left: 26px">
                  <a-select
                    showSearch
                    optionFilterProp="children"
                    @change="changeinfoSourceName"
                    :filterOption="filterOption"
                    v-model="queryParam.infoSourceId"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectSource" :title="type.sourceName" :key="type.sourceId"
                      >{{ type.sourceName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="下单状态" style="margin-left: 26px">
                  <a-select v-model="queryParam.underOrderType" :allowClear="true">
                    <a-select-option value="0" title="系统派单">系统派单</a-select-option>
                    <a-select-option value="1" title="自主下单">自主下单</a-select-option>
                    <a-select-option value="2" title="定向下单">定向下单</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="序列号" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.serialNumber" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="原始订单号" style="margin-left: 13px">
                  <a-input v-model.trim="queryParam.originalOrderNo" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="快递公司" style="margin-left: 26px">
                  <a-select v-model="queryParam.transportCode" :allowClear="true">
                    <a-select-option v-for="type in restaurantTypes4" :title="type.label" :value="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="快递单号" style="margin-left: 26px">
                  <a-input v-model.trim="queryParam.transportNo" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="移除类型" style="margin-left: 26px">
                  <a-select v-model="queryParam.removeType" :allowClear="true">
                    <a-select-option v-for="type in restaurantTypes5" :title="type.label" :value="type.code">{{
                      type.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="移除人" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.removeBy" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="备注" style="margin-left: 55px">
                  <a-input v-model.trim="queryParam.orderRemark" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-row :gutter="24" style="margin-left: 0px">
                  <a-form-item label="客户地址" style="margin-left: 26px;margin-right:12px;">
                    <a-col :md="5" :sm="24">
                      <a-select v-model="queryParam.provinceId" @change="getselect" :allowClear="true">
                        <a-select-option
                          v-for="type in selectAllProvince"
                          :title="type.provinceName"
                          :key="type.provinceCode"
                          >{{ type.provinceName }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                    <a-col :md="5" :sm="24">
                      <a-select v-model="queryParam.cityId" @change="getprovinceName" :allowClear="true">
                        <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :md="5" :sm="24">
                      <a-select v-model="queryParam.countyId" :allowClear="true">
                        <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :md="9" :sm="24">
                      <a-input v-model.trim="queryParam.address" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="建单时间" style="margin-left: 26px">
                  <a-range-picker
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    format="YYYY-MM-DD HH:mm:ss"
                    @change="onChangeTime"
                    style="width: 100%"
                    v-model="create"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="移除时间" style="margin-left: 26px">
                  <a-range-picker
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    format="YYYY-MM-DD HH:mm:ss"
                    @change="onChangeTime2"
                    style="width: 100%"
                    v-model="create2"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <!--<a-row :gutter="24">-->
            <!--<a-col :span="12" style="margin-left:30px">-->
            <!--<a-checkbox @change="onChangeImportant" class="imp">该账号订单</a-checkbox>-->
            <!--</a-col>-->
            <!--</a-row>-->
          </div>
          <div class="table-operator">
            <a-row type="flex" justify="space-between">
              <a-col :span="14"></a-col>
              <a-col :span="10" :style="{ textAlign: 'right' }"> </a-col>
            </a-row>
          </div>
        </a-form>
        <a-form v-if="userType == '22'" layout="inline">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="单号信息">
                <a-input v-model.trim="queryParam.orderInfo" placeholder="订单号/原始订单号" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户信息">
                <a-input v-model.trim="queryParam.clientInfo" placeholder="客户手机号/客户姓名" />
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="移除时间">
                <a-range-picker
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                  @change="onChangeTime2"
                  style="width: 100%"
                  v-model="create2"
                />
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-row>
          <a-col :span="1" :offset="11" v-if="userType != '22'">
            <span v-if="Ifstatus == 0" style="cursor:pointer" @click="getMore"
              ><a-icon type="down-circle" theme="twoTone" style="fontSize:24px"
            /></span>
            <span v-if="Ifstatus == 1" style="cursor:pointer" @click="hiddenMore"
              ><a-icon type="up-circle" theme="twoTone" style="fontSize:24px"
            /></span>
          </a-col>
          <a-col :span="12" :style="{ textAlign: 'right' }" :offset="12">
            <a-button htmlType="submit" type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            <a-button style="margin-left: 8px;" @click="empty">清空</a-button>
            <a-button v-if="exportEnabel" type="primary" style="margin-left: 8px;" @click="exportEnt"
              >导出 Excel</a-button
            >
            <a-button v-if="userType == '22'" type="primary" style="margin-left: 8px;" @click="exportEnt"
              >导出 Excel</a-button
            >
          </a-col>
        </a-row>
      </div>
      <a-divider />
      <s-table size="default" ref="table" bordered :columns="columns" :data="loadData" :scroll="{ x: '5000px' }">
        <span slot="marketPrincipal" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>负责人联系方式:{{ record.principalPhone }}</p>
            </template>
            <span class="hover">{{ text }} </span>
          </a-popover>
        </span>

        <span slot="enterpriseName" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>企业全称:{{ text }}</p>
              <p>负责人:{{ record.enterprisePrincipal }}</p>
              <p>联系方式:{{ record.principalPhone }}</p>
              <p>技术人员:{{ record.technology }}</p>
              <p>技术电话:{{ record.technologyPhone }}</p>
              <p>技术人员2:{{ record.technology2 }}</p>
              <p>技术2电话客服负责人:{{ record.technology2Phone }}</p>
              <p>客服负责人:{{ record.customerService }}</p>
              <p>客服负责人电话:{{ record.customerServicePhone }}</p>
            </template>
            <span class="hover">{{ text }} </span>
          </a-popover>
        </span>

        <span slot="orderType" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>安装类别:{{ record.installType }}</p>
            </template>
            <span class="hover">{{ text }} </span>
          </a-popover>
        </span>
        <span slot="orderNo" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>订单备注:{{ record.orderRemark }}</p>
            </template>
            <span class="hover">{{ text }} </span>
          </a-popover>
          <a title="复制"><a-icon type="copy" class="copy" @click="Copys(record)"/></a>
        </span>
        <span slot="removeType" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>移除原因:{{ record.removeContent }}</p>
            </template>
            <a class="hover">{{ text }} </a>
          </a-popover>
        </span>
        <span slot="masterName" slot-scope="text, record">
          <span class="hover">{{ text }} </span>
          <a title="复制"><a-icon type="copy" class="copy" @click="Copys2(record)"/></a>
        </span>
        <span slot="clientName" slot-scope="text, record">
          <span class="hover">{{ text }} </span>
          <a title="复制"><a-icon type="copy" class="copy" @click="Copys3(record)"/></a>
        </span>
        <span slot="action" slot-scope="text, record" style="white-space: nowrap;">
          <a-tag style="margin-right:30px" color="blue" v-if="detailsEnable" @click="handleEdit(record)">查看</a-tag>
          <a-tag color="orange" v-if="restore" @click="delByIds(record)">恢复</a-tag>
        </span>
      </s-table>
      <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
      <edit-order-model1 v-else ref="editorder"></edit-order-model1>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>

<script>
import moment from 'moment'
import { getselectChannel, getselectSource } from '@/api/order/NewlyaddedOrderList'
import { STable } from '@/components'
import {
  getselectAreaName,
  getselectCityName,
  getselectAllProvince,
  list,
  recover,
  selectbrand,
  selectmodel,
  getfindByDeptId,
  getmarketPrincipal
} from '@/api/order/orderRecovery'
import { getList } from '@/api/order/orderList'
import { checkPermission } from '@/utils/permissions'
import IconText from '../list/search/components/IconText'
import accessoryModal from '../accessory/modules/accessoryModal'
import NoAuthority from '../enterprise/NoAuthority'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getDictMap } from '@/utils/dict'
export default {
  name: 'TableList',
  components: {
    IconText,
    STable,
    accessoryModal,
    NoAuthority,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1')
  },
  data() {
    return {
      // 区
      selectAreaName: '',
      // 市
      selectCityName: '',
      // 省
      selectAllProvince: '',
      // 清除移除时间
      create2: '',
      // 移除开始时间
      removeBeginTime: '',
      // 移除结束时间
      removeEndTime: '',

      // 清除建单时间
      create: '',
      // 建单开始时间
      createBeginTime: '',
      // 建单结束时间
      createEndTime: '',
      // 品牌
      data2: '',
      Ifstatus: 0,
      // 型号
      data3: '',
      // 订单负责人
      data4: '',
      // 市场负责人
      data5: '',
      orderId: '',
      List: [],
      selectChannel: [],
      selectSource: [],
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
          width: 250
        },
        {
          title: '安装类型',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          scopedSlots: { customRender: 'orderType' },
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center'
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'enterpriseName' },
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          scopedSlots: { customRender: 'marketPrincipal' },
          align: 'center'
        },
        {
          title: '负责人电话',
          dataIndex: 'marketPrincipalPhone',
          scopedSlots: { customRender: 'marketPrincipalPhone' },
          align: 'center'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          scopedSlots: { customRender: 'clientName' },
          align: 'center',
          width: 200
        },
        {
          title: '客户电话',
          dataIndex: 'clientPhone',
          align: 'center'
        },
        {
          title: '客户地址',
          dataIndex: 'address'
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          scopedSlots: { customRender: 'masterName' },
          align: 'center',
          width: 200
        },

        {
          title: '师傅电话',
          dataIndex: 'masterPhone',
          align: 'center'
        },
        {
          title: '移除类型',
          dataIndex: 'removeType',
          scopedSlots: { customRender: 'removeType' },
          align: 'center'
        },
        // {
        //   title: '移除原因',
        //   dataIndex: 'removeContent',
        //   align:'center'
        // },

        {
          title: '移除时间',
          dataIndex: 'removeTime',
          align: 'center'
        },
        {
          title: '移除人',
          dataIndex: 'removeBy',
          align: 'center'
        },

        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '订单备注',
          dataIndex: 'orderRemark'
        }
      ],
      // 查询参数
      queryParam: {},
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log(this.queryParam)
        return list(Object.assign(parameter, this.queryParam))
      },
      tech_level: [], // 星级
      selectedRowKeys: [],
      restaurantTypes: [],
      restaurantTypes2: [],
      restaurantTypes3: [],
      restaurantTypes4: [],
      restaurantTypes5: [],
      selectedRows: [],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      detailsEnable: checkPermission('oreder:recovery:details'),
      exportEnabel: checkPermission('oreder:recovery:export'),
      queryList: checkPermission('oreder:recovery:query:list'),
      restore: checkPermission('oreder:recovery:restore'),
      userType: this.$store.getters.userType
    }
  },
  async created() {
    // 安装类型
    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      this.restaurantTypes.push({ code: key, label: value })
    })
    this.selectChannel = []
    await getselectChannel().then(res => {
      if (res.code === 0) {
        // console.log(res)
        this.selectChannel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectSource = []
    // 查询信息来源下拉框
    await getselectSource().then(res => {
      if (res.code === 0) {
        this.selectSource = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    // 字典为安装类型
    this.installTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.installTypes.push({ code: key, label: value })
      // console.log(this.installTypes)
    })
    // 订单状态
    this.restaurantTypes2 = []
    this.restaurantOperTypeMap2 = await getDictMap('order_status')
    this.restaurantOperTypeMap2.forEach((value, key) => {
      this.restaurantTypes2.push({ code: key, label: value })
    })
    // 订单状态
    this.tech_level = []
    this.restaurantOperTypeMap10 = await getDictMap('tech_level')
    this.restaurantOperTypeMap10.forEach((value, key) => {
      this.tech_level.push({ code: key, label: value })
    })

    // 查询品牌
    selectbrand().then(res => {
      console.log(res)
      this.data2 = res.rows
    })

    // 查询型号
    selectmodel().then(res => {
      console.log(res)
      this.data3 = res.rows
    })

    // 订单负责人
    await getfindByDeptId().then(res => {
      this.data4 = res
    })

    // 师傅类型
    this.restaurantTypes3 = []
    this.restaurantOperTypeMap3 = await getDictMap('worker_type')
    this.restaurantOperTypeMap3.forEach((value, key) => {
      this.restaurantTypes3.push({ code: key, label: value })
    })

    // 市场负责人
    await getmarketPrincipal().then(res => {
      this.data5 = res
    })

    // 快递公司
    this.restaurantTypes4 = []
    this.restaurantOperTypeMap4 = await getDictMap('delivery_company')
    this.restaurantOperTypeMap4.forEach((value, key) => {
      this.restaurantTypes4.push({ code: key, label: value })
    })

    // 移除类型
    this.restaurantTypes5 = []
    this.restaurantOperTypeMap5 = await getDictMap('remove_type')
    this.restaurantOperTypeMap5.forEach((value, key) => {
      this.restaurantTypes5.push({ code: key, label: value })
    })

    // 省
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    if (this.userType == '22') {
      this.List = []
      this.queryParam.orderType = ''
      await getList('SMART_SWITCH').then(res => {
        if (res.code === 0) {
          this.List = res.rows
          console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },

  methods: {
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') {
                options[j].title = options[j].text
              }
            }
          }
        }
      }
    },
    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    empty() {
      this.queryParam = {}
      this.create = ''
      this.create2 = ''
      console.log(this.restore)
    },
    // () => queryParam = {}
    moment,
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    exportEnt() {
      var str = process.env.VUE_APP_API_BASE_URL + '/order/OrderRemove/export?pageNum=1&pageSize=10'
      for (const i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
    },
    async installChange(e) {
      this.List = []
      this.queryParam.orderType = ''
      await getList(e).then(res => {
        if (res.code === 0) {
          this.List = res.rows
          console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 查看
    handleEdit(record) {
      console.log(record)
      this.$refs.editorder.showeditOrder(record.orderId, 1, 0)
    },

    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    delByIds(record) {
      let _this = this
      this.$confirm({
        title: '确认恢复吗？',
        okText: '确认',
        cancelText: '取消',
        centered: true,
        onOk() {
          _this.orderId = record.orderId
          recover({ orderId: _this.orderId }).then(res => {
            if (res.code === 0) {
              _this.$message.success('恢复成功')
              _this.handleOk()
            } else {
              _this.$message.error(res.msg)
            }
          })
        }
      })
    },
    handleOk() {
      this.$refs.table.refresh()
    },
    handcopy(data) {
      const url = data
      const oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },

    Copys(val) {
      console.log(val)
      this.copyData =
        `订单号:` +
        val.orderNo +
        '\n' +
        `客户姓名:` +
        val.clientName +
        '\n' +
        `客户联系方式:` +
        val.clientPhone +
        '\n' +
        `客户地址:` +
        val.address
      this.handcopy(this.copyData)
    },

    Copys2(val) {
      console.log(val)
      this.copyData = `师傅姓名:` + val.masterName + '\n' + `师傅联系方式:` + val.masterPhone
      this.handcopy(this.copyData)
    },
    Copys3(val) {
      console.log(val)
      this.copyData =
        `客户姓名:` + val.clientName + '\n' + `客户联系方式:` + val.clientPhone + '\n' + `客户地址:` + val.address
      this.handcopy(this.copyData)
    },
    // 建单时间
    onChangeTime(date, dateString) {
      // 开始时间
      this.queryParam.createBeginTime = dateString[0]
      // 结束时间
      this.queryParam.createEndTime = dateString[1]
    },

    // 移除时间
    onChangeTime2(date, dateString) {
      // 开始时间
      this.queryParam.removeBeginTime = dateString[0]
      // 结束时间
      this.queryParam.removeEndTime = dateString[1]
    }
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 6px 16px;
}
</style>
